export default function TexteLocal() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-blue">
            Votre réparateur de volet roulant à Haguenau
          </h2>
        </div>
        <div className="space-y-6 text-brand-text text-base leading-relaxed">
          <p>
            Située au nord du Bas-Rhin, Haguenau est une ville au patrimoine historique riche qui compte de nombreux logements équipés de volets roulants. Notre équipe de techniciens intervient régulièrement à Haguenau pour la réparation, la motorisation et la pose de volets roulants. Que vous habitiez dans le centre historique, les quartiers résidentiels périphériques ou les communes voisines de la forêt de Haguenau, nous nous déplaçons rapidement pour résoudre tous vos problèmes de volets, quelle que soit la marque ou le modèle installé.
          </p>
          <p>
            À Haguenau, les volets roulants des logements récents comme des maisons anciennes doivent faire face aux vents du nord et aux variations thermiques. Les pannes de moteurs et d'axes d'enroulement sont les plus courantes dans cette zone. Nous intervenons sur toutes les marques avec des pièces adaptées à chaque configuration. Chaque déplacement à Haguenau commence par un diagnostic gratuit, suivi d'un devis clair. Vous ne payez que les réparations effectuées, avec une garantie de dix ans sur les installations.
          </p>
        </div>
      </div>
    </section>
  );
}